<template src="./template.html" />

<script>
import { Stage, Button } from '@neurotrack/web-shared-components'
import ButtonGroup from '@/components/ButtonGroup'
import Timer from '@/mixins/timer'

export default {
  components: { Stage, Button, ButtonGroup },
  mixins: [Timer],
  data() {
    return {
      timerTriggered: false
    }
  },
  watch: {
    step: {
      handler() {
        this.timedDisplay()
      },
      immediate: true
    }
  },
  async mounted() {
    this.timedDisplay()
  },
  methods: {
    handleAnswer(value) {
      this.timerTriggered = false
      this.clearTimer()
      this.$emit('answered', value)
    },
    timedDisplay() {
      if (!this.timerTriggered) {
        this.timerTriggered = true
        this.clearTimer()
        this.setTimer(this.displaySeconds * 1000, 'delay').then(() => {
          this.timerTriggered = false
          this.handleAnswer(null)
        })
      }
    }
  },
  props: {
    leadingImageUrl: String,
    trailingImageUrl: String,
    leadingButtonText: String,
    leadingButtonValue: String,
    trailingButtonText: String,
    trailingButtonValue: String,
    displaySeconds: {
      type: Number,
      default: 4
    },
    step: Number
  }
}
</script>

<style scoped lang="scss">
@import './style.scss';
</style>
